import { formatCurrency } from '@koob/utils';
import { useTranslation } from 'react-i18next';

export default function ReceiptContentTotal({
  price,
  currency,
  showConvertedColumn,
}) {
  const { t } = useTranslation('trips');

  return (
    <div className="py-5 border-t border-gray-200 flex justify-between items-center text-gray-800 font-medium">
      <div>{t('receipt.total')}</div>

      <div className="mr-6">
        {formatCurrency({
          amount: price,
          currency: currency,
          noDecimals: showConvertedColumn,
        })}
      </div>
    </div>
  );
}
